import { useState, useEffect } from 'react';
import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, PASSWORD_LENGTH_MESSAGE } from '@/constants/users';

export const usePasswordValidation = (password: string) => {
  const [passwordStatus, setPasswordStatus] = useState<'idle' | 'valid' | 'invalid'>('idle');
  const [passwordMessage, setPasswordMessage] = useState('');

  useEffect(() => {
    if (!password) {
      setPasswordStatus('idle');
      setPasswordMessage('');
      return;
    }

    if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) {
      setPasswordStatus('invalid');
      setPasswordMessage(PASSWORD_LENGTH_MESSAGE);
      return;
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const typeCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;

    if (typeCount < 2) {
      setPasswordStatus('invalid');
      setPasswordMessage('대소문자, 숫자, 특수문자 중 최소 2가지 이상을 조합해 주세요.');
      return;
    }

    setPasswordStatus('valid');
    setPasswordMessage('사용 가능한 비밀번호입니다.');
  }, [password]);

  return {
    passwordStatus,
    passwordMessage,
  };
};

